import { Form, Input, Grid, Select, DatePicker2, Upload, Icon, Field, Dialog, Button, Radio, Table, Pagination } from "@alifd/next";
import { BefGlobalContext, BefMenuServiceContext, BefMessageServiceContext, BefRpcContext } from "@beflam/bef-core";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import ChangePassword from "./ChangePassword";
import EditUserDialog from "./EditUserDialog";
import { ContainerOutlined, HomeOutlined, UserOutlined } from '@ant-design/icons';
import { lastValueFrom } from "rxjs";
import dayjs, { Dayjs } from "dayjs";

const { Row, Col } = Grid;
const RadioGroup = Radio.Group;
export function BefUserAvatar(props: any) {
    const { value, ...otherProps } = props;
    const sGlobal = useContext(BefGlobalContext);
    return (
        <div {...otherProps}>
            <img style={{ maxWidth: "100%", maxHeight: "100%", position: "absolute", top: 0, right: 0, bottom: 0, left: 0, margin: "auto" }}
                alt={value} src={value ? `${sGlobal.config.host}/${value}` : './assets/img/avatar1.png'}></img>
        </div>
    );
}
const EditUser = forwardRef((props: any, ref) => {
    const perRef = useRef(null);
    const [divHeight, setDivHeight] = useState<any>(0);
    const { rpcAssembly, rpcModule, id, readonly, isUser, ...otherProps } = props;
    const befRpc = useContext(BefRpcContext);
    const messageService = useContext(BefMessageServiceContext);
    const sGlobal = useContext(BefGlobalContext);
    const [dataSource, setDataSource] = useState<any>({});
    let [visible, setVisible] = useState({ changePassword: false, edit: false });
    let contextComp: any = {};
    let [roleDatasource, SetRoleDatasource] = useState<any>({ source: [], columnWidth: {}, currentPage: 1 });//role
    let [perDatasource, SetPerDatasource] = useState<any>({ source: [], columnWidth: {}, currentPage: 1 });//peprmission
    let [depDatasource, SetDepDatasource] = useState<any>({ source: [], columnWidth: {}, currentPage: 1 });//dep
    let [isRole, setIsRole] = useState<string>('role');
    const menu = useContext(BefMenuServiceContext);
    const [menuData, setMenuData] = useState<any>([]);
    const [mMenuData, setMMenuData] = useState<any>([]);
    const [webPage, setWebPage] = useState<any>('');
    const [mobilePage, setMobilePage] = useState<any>('');
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));
    const readUserRef = useRef<any>();
    const [agentSetting, setAngetSetting] = useState<any>("");
    const setVisibleEx = (data: any) => {
        visible = data;
        setVisible(data);
    }
    const refresh = async () => {
        try {
            const result = await befRpc.callRpcAsync<any>("", rpcAssembly, rpcModule, "Get", { UserId: id });
            fieldRef.current.setValues(result);
            readUserRef.current = result;
            SetRoleDatasourceEx({ source: result.Roles, data: result.Roles, columnWidth: {} as any, currentPage: 1 });
            SetPerDatasourceEx({ source: result.Permissions, columnWidth: {} as any, currentPage: 1 });

            SetDepDatasourceEx({ source: result.Departments, data: result.Departments, columnWidth: {} as any, currentPage: 1 });
            setAngetSetting(result?.AgentSetup);
            if (result.Avatar) {
                let url = `${sGlobal.config.host}/${result.Avatar}`;
                fieldRef.current.setValue("AvatarUploadData", [{
                    name: result.Avatar,
                    state: "done",
                    size: 1024,
                    downloadURL: url,
                    fileURL: url,
                    imgURL: url
                }]);
            } else {
                fieldRef.current.setValue("AvatarUploadData", []);
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "用户信息获取"));
        }
    }
    const SetRoleDatasourceEx = (data: any) => {
        roleDatasource = data;
        SetRoleDatasource(data);
    }
    const SetPerDatasourceEx = (data: any) => {
        perDatasource = data;
        SetPerDatasource(data);
    }
    const SetDepDatasourceEx = (data: any) => {
        depDatasource = data;
        SetDepDatasource(data);
    }
    const saveData = async () => {
        let data: any = fieldRef.current.getValues();
        let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Update", data);
        messageService.showMessage({ mes: `修改用户<${data.UserId}>信息成功` });
        return result;
    }
    const save = async () => {
        try {
            await saveData();
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "用户信息保存"));
        }
    }

    let userRef = useRef<any>(null);
    const openChangePasswordDialog = () => {
        try {
            setVisibleEx({ ...visible, changePassword: true });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "修改密码"));
        }
    }
    const onChangePassword = async () => {
        try {
            if (!userRef || !userRef.current) throw new Error("系统错误：userRef is null");
            let validateResult = await userRef.current.validate();
            if (validateResult.errors != null) return;
            let data = userRef.current.dataSource;
            data.Reset = true;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "ChangePassword", data);
            messageService.showMessage({ mes: `修改密码成功` });
            setVisibleEx({ ...visible, changePassword: false });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "修改密码"));
        }
    }

    const onAvatarUploadChange = (value: any[]) => {
        let data = null;
        if (value && value.length > 0) {
            data = value[0].response?.fileId;
        }
        fieldRef.current.setValue("Avatar", data);
    }
    const uploadFormatterHandler = (response: any, file: File) => {
        return {
            success: response.success,
            message: response.success ? "上传成功" : response.error,
            url: `${sGlobal.config.host}/${response.fileId}`,
            fileId: response.fileId
        };
    }
    const onRadioChange = (value: any, event: any) => {
        // if (value === "role")
        //     setIsRole(true);
        // else
        //     setIsRole(false);
        setIsRole(value);
        if (value === 'page')
            GetMenus();
    }
    const onEdit = async () => {
        try {
            if (!userRef || !userRef.current) throw new Error("系统错误：userRef is null");
            await userRef.current.save();
            setVisibleEx({ ...visible, edit: false });
            refresh();
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "用户编辑"));
        }
    }
    const openEditDialog = () => {
        try {
            if (readUserRef.current?.UserId === "") throw new Error("缺少UserId");
            setVisibleEx({ ...visible, edit: true });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "用户编辑"));
        }
    }
    const GetMenus = async (_isShow: boolean = false) => {
        try {
            let res = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "GetExtendData", { key: '__WebHomepage' });
            if (res)
                setWebPage(res);
            else setWebPage('');
            let res1 = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "GetExtendData", { key: '__MobileHomepage' });
            if (res1)
                setMobilePage(res1);
            else
                setMobilePage('');
            menu.getMenuGroups().subscribe((result: any) => {
                if (result) {
                    let _datas: any[] = [];
                    result.map((res: any) => {
                        if (res) {
                            let temp = res.Groups.filter((item: any) => item.ID !== "__starMenuGroup");
                            _datas = _datas.concat(temp);
                        }
                    });

                    let _dd = [] as any;
                    _datas.map(it => {
                        _dd.push({ label: it.Text, children: getMenuItems1(it) });
                    })
                    setMenuData(_dd);
                };

            });
            menu.getMenuGroups(9).subscribe((result: any) => {
                if (result) {
                    let _datas: any[] = [];
                    result.map((res: any) => {
                        if (res) {
                            let temp = res.Groups.filter((item: any) => item.ID !== "__starMenuGroup");
                            _datas = _datas.concat(temp);
                        }
                    });
                    //  setMMenuData(_datas)
                    let _dd = [] as any;
                    _datas.map(it => {
                        _dd.push({ label: it.Text, children: getMenuItems1(it) });
                    })
                    setMMenuData(_dd)
                }
            });


        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "菜单获取"));
        }
    }

    // const getMenuItems = (items: any) => {
    //     let result;
    //     if (items && items.length > 0) {
    //         result = items.map((item: any) => {
    //             if (!item.Items) {
    //                 return <Select.Option value={item.ID}>{item.Text}-{item.ID}</Select.Option>
    //             } else {
    //                 getMenuItems(item);
    //             }
    //         });
    //     }
    //     return result
    // }

    const getMenuItems1 = (items: any) => {
        let result = [] as any;
        if (items.Items && items.Items.length > 0) {
            items.Items.map((item: any) => {
                if (!item.Items) {
                    result.push({ label: `${item.Text}-${item.ID}`, value: item.ID });
                } else {
                    result = result.concat(getMenuItems1(item));
                }
            });
        }
        return result;
    }
    const saveHomePage = async () => {
        try {
            let _data = '';
            if (webPage)
                _data = webPage;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "SetExtendData", { key: '__WebHomepage', data: _data });
            let _data1 = '';
            if (mobilePage)
                _data1 = mobilePage;
            await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "SetExtendData", { key: '__MobileHomepage', data: _data1 });

            messageService.showMessage({ mes: `主页设置成功` });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "主页设置"));
        }
    }
    const saveAgent = async () => {
        try {
            let data: any = fieldRef.current.getValues();
            data.AgentSetup = agentSetting;
            let result = await befRpc.callRpcAsync("", rpcAssembly, rpcModule, "Update", data);
            messageService.showMessage({ mes: `AI助理设置成功` });
        } catch (errors) {
            messageService.showMessage(messageService.handleErr(errors, "AI助理设置"));
        }

    }
    useEffect(() => {
        fieldRef.current.reset();
    }, []);
    useEffect(() => {
        if (id) {
            fieldRef.current.setValue("UserId", id);
            refresh();
        }
    }, [id]);
    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                //   console.log('Element size changed:', width, height);
                let _height = height;
                if (height > 0) {
                    if (_height - 125.25 > 0)
                        setDivHeight((_height - 125.25) + 'px');
                    else
                        setDivHeight('232px');
                }

            }
        });

        if (perRef.current) {
            resizeObserver.observe(perRef.current);
        }

        return () => {
            if (perRef.current) {
                resizeObserver.unobserve(perRef.current);
            }
        };
    }, [isRole, menuData]);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        proxy.save = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate(async (errors: any, values: any) => {
                        try {
                            if (errors != null) return;
                            let result = await saveData();
                            resolve(result);
                        } catch (error) {
                            reject(error);
                        }
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, [rpcAssembly, rpcModule]);
    return (
        <>
            <div className="bef-user bef-user-padding-ex" >
                {/* <div className="user-info-content">

                </div>
                <div className=" user-other-content">

                </div> */}
                <div className="h-100 display-flex" >
                    <div className="col-padding" style={{ flex: 1 }}>
                        <div className=" custom-card h-100">
                            <div className="bef-user-info h-100 " style={{ gap: '24px' }}>
                                <div className="bef-user-center-div margin-bottom-16">
                                    <BefUserAvatar value={readUserRef.current?.Avatar} style={{ position: "relative", border: "none", width: "100px", height: "100px" }}></BefUserAvatar>
                                </div>
                                <h5 className="margin-bottom-16 text-center">{readUserRef.current?.UserName}</h5>
                                <div className="h5-div margin-bottom-16">
                                    <h5 className="margin-bottom-16">Details</h5>
                                </div>
                                <div style={{ overflowY: 'auto', overflowX: "hidden" }}>
                                    <p className="margin-bottom-16"><span className="p-label">用户名称</span>：<span>{readUserRef.current?.UserName}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">用户编号</span>：<span>{readUserRef.current?.UserId}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">性别</span>：<span>{readUserRef.current?.Gender && readUserRef.current?.Gender === 1 && '男'}
                                        {readUserRef.current?.Gender && readUserRef.current?.Gender === 0 && '女'}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">出生日期</span>：<span>{dayjs(readUserRef.current?.Birthday).format("YYYY-MM-DD")}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">语言</span>：<span>{readUserRef.current?.Language}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">邮箱</span>：<span>{readUserRef.current?.Email}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">手机号码</span>：<span>{readUserRef.current?.PhoneNumber}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">办公电话</span>：<span>{readUserRef.current?.TelNumber}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">身份证号码</span>：<span>{readUserRef.current?.IdentityNumber}</span></p>
                                    <p className="margin-bottom-16"><span className="p-label">地址</span>：<span>{readUserRef.current?.Address}</span></p>
                                    <div className="bef-user-center-div margin-bottom-16">
                                        <Button className="custom-primary  margin-right-16 custom-btn" onClick={openEditDialog}>编辑</Button>
                                        <Button type="normal" className="font-14 custom-btn" onClick={openChangePasswordDialog} >修改密码</Button>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="col-padding" style={{ flex: 3, overflow: 'auto' }}>
                        <div className="bef-user-moreinfo">
                            <div className=" margin-bottom-24">
                                <RadioGroup
                                    shape="button"
                                    defaultValue="role"
                                    onChange={onRadioChange}
                                >
                                    <Radio id="role" value="role" className="custom-button-radio ">
                                        {/* <Icon type="account" className="margin-right-8 radiogroup-i" /> */}
                                        <UserOutlined className="margin-right-8 radiogroup-i" />
                                        <span className="text">角色&权限</span>
                                    </Radio>
                                    <Radio id="dep" className="custom-button-radio" value="dep">
                                        {/* <Icon type="detail no-border" className="margin-right-8  radiogroup-i" size="small" /> */}
                                        <ContainerOutlined className="margin-right-8 radiogroup-i" />
                                        <span className="text">部门</span>
                                    </Radio>
                                    <Radio id="dep" className="custom-button-radio" value="page">
                                        <HomeOutlined className="margin-right-8 radiogroup-i" />
                                        <span className="text">主页设置</span>
                                    </Radio>
                                    <Radio id="dep" className="custom-button-radio" value="aisetting">
                                        <i className="margin-right-8 radiogroup-i">
                                            <svg
                                                viewBox="0 0 1024 1024"
                                                width="1em"
                                                height="1em"
                                                fill="currentColor"
                                            >
                                                <path d="M269.69088 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464s68.46464-30.64832 68.46464-68.46464c0-37.80608-30.65856-68.46464-68.46464-68.46464s-68.46464 30.65856-68.46464 68.46464zM899.54304 1.21856H123.63776c-20.19328 0-36.51584 16.32256-36.51584 36.51584v753.09056c0 20.19328 16.32256 36.5056 36.51584 36.5056h775.90528c20.19328 0 36.5056-16.31232 36.5056-36.5056V37.7344c0.01024-20.19328-16.30208-36.51584-36.5056-36.51584zM863.0272 754.30912H160.14336V74.25024H863.0272v680.05888zM616.56064 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464 37.81632 0 68.46464-30.64832 68.46464-68.46464 0-37.80608-30.64832-68.46464-68.46464-68.46464-37.80608 0-68.46464 30.65856-68.46464 68.46464z m285.4912 634.4192H121.12896c-18.82112 0-34.00704 16.32256-34.00704 36.51584v41.07264c0 5.02784 3.76832 9.13408 8.448 9.13408h831.92832c4.67968 0 8.448-4.10624 8.448-9.13408v-41.07264c0.11264-20.20352-15.06304-36.51584-33.8944-36.51584zM685.02528 507.84256H338.15552c-5.0176 0-9.12384 4.10624-9.12384 9.13408v68.46464c0 5.0176 4.10624 9.12384 9.12384 9.12384h346.88c5.0176 0 9.13408-4.10624 9.13408-9.12384v-68.46464c-0.01024-5.02784-4.11648-9.13408-9.14432-9.13408z m0 0" />
                                            </svg>
                                        </i>
                                        <span className="text">AI助理设置</span>
                                    </Radio>
                                </RadioGroup>
                            </div>
                            {isRole === 'role' && <> <div className="custom-card margin-bottom-24">
                                <div className="bef-user-table-div">
                                    <h5>角色</h5>
                                    <div className=" custom-table " >
                                        <Table.StickyLock hasBorder={false} size='medium' maxBodyHeight="174px"
                                            fixedHeader
                                            primaryKey="UserId"
                                            dataSource={roleDatasource?.source}
                                            onResizeChange={(dataIndex: string, value: number) => {
                                                let newData = { ...roleDatasource.columnWidth };
                                                newData[dataIndex] = (newData[dataIndex] ?? 0) + value;
                                                SetRoleDatasourceEx({ ...roleDatasource, columnWidth: newData });
                                            }}>
                                            <Table.Column title="角色编号" dataIndex="Id" width={roleDatasource?.columnWidth?.Id} />
                                            <Table.Column title="角色名称" dataIndex="Description" width={roleDatasource?.columnWidth?.Description} />
                                            <Table.Column title="授权日期" dataIndex="CreateDate" width={roleDatasource?.columnWidth?.CreateDate} cell={(value, index, record) => value ? new Intl.DateTimeFormat('zh-CN').format(new Date(value)) : ''} />
                                        </Table.StickyLock></div>

                                </div>

                            </div>
                                <div className="custom-card flex-1" ref={perRef} style={{ overflow: 'hidden' }}>
                                    <div className="bef-user-table-div div-per h-100">
                                        <h5>权限</h5>
                                        <div className=" custom-table flex-1">
                                            <Table.StickyLock hasBorder={false} size='medium' maxBodyHeight={divHeight} className="flex-1"
                                                primaryKey="UserId" fixedHeader
                                                dataSource={perDatasource?.source}
                                                onResizeChange={(dataIndex: string, value: number) => {
                                                    let newData = { ...perDatasource.columnWidth };
                                                    newData[dataIndex] = (newData[dataIndex] ?? 0) + value;
                                                    SetPerDatasourceEx({ ...perDatasource, columnWidth: newData });
                                                }}>
                                                <Table.Column title="权限编号" dataIndex="Id" width={perDatasource?.columnWidth.Id} />
                                                <Table.Column title="权限名称" dataIndex="Description" width={perDatasource?.columnWidth.Description} />
                                                <Table.Column title="权限角色名称" dataIndex="RoleDescription" width={perDatasource?.columnWidth.RoleDescription} />
                                                <Table.Column title="授权日期" dataIndex="CreateDate" width={perDatasource?.columnWidth.CreateDate} cell={(value, index, record) => value ? new Intl.DateTimeFormat('zh-CN').format(new Date(value)) : ''} />
                                            </Table.StickyLock>

                                        </div>

                                    </div>
                                </div></>}
                            {isRole === 'dep' && <div className="custom-card margin-bottom-24">
                                <div className="bef-user-table-div">
                                    <h5 className="margin-bottom-16">部门</h5>
                                    <div className=" custom-table ">
                                        <Table.StickyLock hasBorder={false} size='medium' maxBodyHeight="406px"
                                            fixedHeader
                                            primaryKey="UserId"
                                            dataSource={depDatasource?.source}
                                            onResizeChange={(dataIndex: string, value: number) => {
                                                let newData = { ...depDatasource.columnWidth };
                                                newData[dataIndex] = (newData[dataIndex] ?? 0) + value;
                                                SetDepDatasourceEx({ ...depDatasource, columnWidth: newData });
                                            }}>
                                            <Table.Column title="部门编号" dataIndex="Id" width={depDatasource?.columnWidth?.Id} />
                                            <Table.Column title="部门名称" dataIndex="Name" width={depDatasource?.columnWidth?.Name} />
                                            <Table.Column title="职级" dataIndex="TypeName" width={depDatasource?.columnWidth?.TypeName} />
                                        </Table.StickyLock></div>
                                    {/* <div className="margin-bottom-16 dep-div">
                                        <div>
                                            <label className="font-14 margin-right-8">部门</label>
                                            <p> 测试数据</p></div>
                                        <div>
                                            <label className="font-14 margin-right-8">职级</label>
                                            <p> 测试数据</p></div>
                                    </div> */}
                                </div>
                            </div>}
                            {isRole === 'page' && <div className="custom-card margin-bottom-24">
                                <div className="bef-user-table-div">
                                    <h5 className="margin-bottom-16">主页设置</h5>

                                    <div className="margin-bottom-16" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button className=" custom-btn save-btn" onClick={saveHomePage}>保存</Button></div>
                                    <div style={{ display: 'flex', gap: 16 }}>
                                        <div className="custom-form-control" style={{ flex: 1 }} >
                                            <label>Web 主页</label>
                                            <Select style={{ width: '100%' }} showSearch hasClear value={webPage} onChange={(value) => {
                                                //  console.log(value);
                                                setWebPage(value);
                                            }} dataSource={menuData}>
                                                {/* {menuData.map((item: any) => {
                                                    let _items = [] as any;
                                                    if (item.Items && item.Items.length > 0) {
                                                        return <Select.OptionGroup label={item.Text}>
                                                            {getMenuItems(item.Items)}
                                                        </Select.OptionGroup>
                                                    }

                                                })} */}
                                            </Select>
                                        </div>
                                        <div className="custom-form-control" style={{ flex: 1 }} >
                                            <label>Mobile 主页</label>
                                            <Select style={{ width: '100%' }} hasClear showSearch value={mobilePage} onChange={(value) => {

                                                setMobilePage(value);
                                            }} dataSource={mMenuData}>
                                                {/* {mMenuData.map((item: any) => {
                                                    let _items = [] as any;
                                                    if (item.Items && item.Items.length > 0) {
                                                        return <Select.OptionGroup label={item.Text}>
                                                            {getMenuItems(item.Items)}
                                                        </Select.OptionGroup>
                                                    }

                                                })} */}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {isRole === 'aisetting' && <> <div className="custom-card margin-bottom-24">
                                <div className="bef-user-table-div">
                                    <h5 className="margin-bottom-16">AI助理设置</h5>
                                    <div className="margin-bottom-16" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button className=" custom-btn save-btn" onClick={saveAgent}>保存</Button>
                                    </div>
                                    <div style={{ display: 'flex', gap: 16 }}>
                                        <div className="custom-form-control" style={{ flex: 1 }} >
                                            <Input.TextArea rows={15} style={{ width: '100%' }} name="AgentSetup" value={agentSetting} onChange={(val) => { setAngetSetting(val); }} />
                                        </div>

                                    </div>
                                </div>
                            </div></>}
                        </div>
                    </div>
                </div>
            </div>
            <Dialog v2 title="编辑用户" width={800} visible={visible.edit} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, edit: false })} onOk={onEdit}>
                <EditUserDialog isUser={true} ref={userRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule}
                    id={readUserRef.current?.UserId} />
            </Dialog>
            <Dialog v2 title="修改密码" width={400} visible={visible.changePassword} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, changePassword: false })} onOk={onChangePassword}>
                <ChangePassword ref={userRef} rpcAssembly={rpcAssembly} rpcModule={rpcModule} id={id} />
            </Dialog>
        </>
    );
});

export default EditUser;